import React from 'react';
import styled from 'styled-components';
import xeroIcon from '~/assets/public/xero-icon.png';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  height: 1.2rem;
  margin-top: -0.25rem;
  margin-bottom: 0.05rem;
`;

const Image = styled.img.attrs({ src: xeroIcon })`
  width: 1rem;
  height: 1rem;
  filter: grayscale(100%);
  opacity: 0.6;
`;

export default function XeroGrey() {
  return (
    <Wrapper>
      <Image />
    </Wrapper>
  );
}
